import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { PendingDotsSkeleton } from "../../components/Shared/LoadingSkeletons/PendingDotsSkeleton/PendingDotsSkeleton";
import { translationKeys } from "../../models/app-translation-keys";
import { useThreadService } from "../../services/ServiceHooks/threadHook";
import { useStore } from "../../stores/StoreContext";
import { ThreadHistoryList } from "./ThreadHistoryList/ThreadHistoryList";

const RawChatThreadHistory: FunctionComponent = () => {
  const { threadStore } = useStore();

  const threadService = useThreadService();

  useEffect(() => {
    const loadThreads = async () => {
      await threadService.loadThreads();
    };

    if (!threadStore.threads?.length) {
      loadThreads();
    }
  }, []);

  // don't show loading spinner once we have threads
  if (threadStore.loadingThreads && !threadStore.threads?.length) {
    return <PendingDotsSkeleton translationKey={translationKeys.feature.chatbot.history.loadingHistory} />;
  }

  return (
    <ThreadHistoryList
      threads={threadStore.threads}
      activeThreadId={threadStore.activeThread?.id}
      showDateSeparators={true}
    />
  );
};

export const ChatThreadHistory = observer(RawChatThreadHistory);
